import { GET_MASTER_OPTIONS, MASTER_OPTIONS_REQUEST, SET_ADD_MASTER_IN_OPTIONS, SET_UPDATE_MASTER_IN_OPTIONS, MASTER_OPTIONS_REQUEST_FAILURE,
  SET_ACCOUNTS_DATA_IN_OPTIONS, GET_MASTER_ALL_OPTIONS, SET_RELOAD_MASTER_PAYLOAD, UPDATE_ACCOUNT_IN_MASTER_OPTIONS, ADD_ACCOUNT_IN_MASTER_OPTIONS,
  DELETE_ACCOUNT_IN_MASTER_OPTIONS, UPDATE_BOOK_IN_MASTER_OPTIONS, ADD_BOOK_IN_MASTER_OPTIONS, DELETE_BOOK_IN_MASTER_OPTIONS,
  UPDATE_ITEM_IN_MASTER_OPTIONS, ADD_ITEM_IN_MASTER_OPTIONS, DELETE_ITEM_IN_MASTER_OPTIONS } from "../types";
import * as _ from 'lodash';

const initialState = {
  accountsData: [],
  accounts: {
    activeAccountsData: [],
    accountsMap: new Map(),
  },
  allOptions: {},
  options: {},
  loading: false,
  error: null,
  isLoaded: false,
  lastFetchedAt: null
};

const masterOptionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case MASTER_OPTIONS_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_MASTER_ALL_OPTIONS: {
      return {
        ...state,
        allOptions: { ...state.allOptions, ...action.payload },
        loading: false,
        error: null
      }
    }
    case GET_MASTER_OPTIONS: {
      return {
        ...state,
        options: { ...state.options, ...action.payload },
        loading: false,
        error: null
      }
    }
    case MASTER_OPTIONS_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    case SET_ADD_MASTER_IN_OPTIONS: {
      const { name, data } = action.payload || {};
      const masterData = state.options[name]?.slice(0) || [];
      const allMasterData = state.allOptions[name]?.slice(0) || [];
      return {
        ...state,
        options: {
          ...(state.options || {}),
          [name]: [data, ...masterData],
        },
        allOptions: {
          ...(state.allOptions || {}),
          [name]: [data, ...allMasterData],
        }
      }
    }
    case SET_UPDATE_MASTER_IN_OPTIONS: {
      const { name, id, data } = action.payload || {};
      const masterData = state.options[name]?.slice(0) || [];
      const allMasterData = state.allOptions[name]?.slice(0) || [];
      const uIndex = masterData.findIndex((data) => data.id === id);
      const auIndex = allMasterData.findIndex((data) => data.id === id);
      if (data) {
        masterData.splice(uIndex, 1, { ...data });
        allMasterData.splice(auIndex, 1, { ...data });
      } else {
        masterData.splice(uIndex, 1);
        allMasterData.splice(auIndex, 1);
      }
      return {
        ...state,
        options: {
          ...(state.options || {}),
          [name]: [...masterData],
        },
        allOptions: {
          ...(state.allOptions || {}),
          [name]: [...allMasterData],
        }
      }
    }
    case SET_ACCOUNTS_DATA_IN_OPTIONS: {
      const { accountsData, activeAccountsData, accountsMap } = action.payload || {};
      return {
        ...state,
        accountsData: accountsData || [],
        accounts: {
          activeAccountsData: activeAccountsData || [],
          accountsMap: accountsMap || new Map(),
        }
      }
    }
    case SET_RELOAD_MASTER_PAYLOAD: {
      return {
        ...state,
        ...(action.payload || {})
      }
    }
    case UPDATE_ACCOUNT_IN_MASTER_OPTIONS: {
      const accId = parseInt(action.payload?.id) || 0;
      const data = action.payload?.data;
      const accountsData = state.options?.accounts?.slice(0) || [];
      const allAccountsData = state.allOptions?.accounts?.slice(0) || [];
      if (data) {
        if (accountsData?.length) {
          const index = accountsData.findIndex((val) => val.id === accId);
          if (index > -1) {
            accountsData.splice(index, 1, data);
          }
        }
        if (allAccountsData?.length) {
          const indexPage = allAccountsData.findIndex((val) => val.id === accId);
          if (indexPage > -1) {
            allAccountsData.splice(indexPage, 1, data);
          }
        }
      }
      return {
        ...state,
        options: {
          ...(state.options || {}),
          accounts: accountsData
        },
        allOptions: {
          ...(state.allOptions || {}),
          accounts: allAccountsData
        },
      }
    }
    case ADD_ACCOUNT_IN_MASTER_OPTIONS: {
      const data = action.payload?.data;
      const accountsData = state.options?.accounts?.slice(0) || [];
      const allAccountsData = state.allOptions?.accounts?.slice(0) || [];
      if (data) {
        accountsData.push(data);
        allAccountsData.push(data);
      }
      return {
        ...state,
        options: {
          ...(state.options || {}),
          accounts: _.orderBy(accountsData, ['Party_Name'], ['asc'])
        },
        allOptions: {
          ...(state.allOptions || {}),
          accounts: _.orderBy(allAccountsData, ['Party_Name'], ['asc'])
        },
      }
    }
    case DELETE_ACCOUNT_IN_MASTER_OPTIONS: {
      const accId = parseInt(action.payload?.id) || 0;
      const accountsData = state.options?.accounts?.slice(0) || [];
      const allAccountsData = state.allOptions?.accounts?.slice(0) || [];
      if (accId) {
        if (accountsData?.length) {
          const index = accountsData.findIndex((val) => val.id === accId);
          if (index > -1) {
            accountsData.splice(index, 1);
          }
        }
        if (allAccountsData?.length) {
          const indexPage = allAccountsData.findIndex((val) => val.id === accId);
          if (indexPage > -1) {
            allAccountsData.splice(indexPage, 1);
          }
        }
      }
      return {
        ...state,
        options: {
          ...(state.options || {}),
          accounts: accountsData
        },
        allOptions: {
          ...(state.allOptions || {}),
          accounts: allAccountsData
        },
      }
    }
    case UPDATE_BOOK_IN_MASTER_OPTIONS: {
      const bookId = parseInt(action.payload?.id) || 0;
      const data = action.payload?.data;
      const booksData = state.options?.books?.slice(0) || [];
      const allBooksData = state.allOptions?.books?.slice(0) || [];
      if (data) {
        if (booksData?.length) {
          const index = booksData.findIndex((val) => val.id === bookId);
          if (index > -1) {
            booksData.splice(index, 1, data);
          }
        }
        if (allBooksData?.length) {
          const indexPage = allBooksData.findIndex((val) => val.id === bookId);
          if (indexPage > -1) {
            allBooksData.splice(indexPage, 1, data);
          }
        }
      }
      return {
        ...state,
        options: {
          ...(state.options || {}),
          books: booksData
        },
        allOptions: {
          ...(state.allOptions || {}),
          books: allBooksData
        },
      }
    }
    case ADD_BOOK_IN_MASTER_OPTIONS: {
      const data = action.payload?.data;
      const booksData = state.options?.books?.slice(0) || [];
      const allBooksData = state.allOptions?.books?.slice(0) || [];
      if (data) {
        booksData.unshift(data);
        allBooksData.unshift(data);
      }
      return {
        ...state,
        options: { 
          ...(state.options || {}),
          books: booksData
        },
        allOptions: {
          ...(state.allOptions || {}),
          books: allBooksData
        },
      }
    }
    case DELETE_BOOK_IN_MASTER_OPTIONS: {
      const bookId = parseInt(action.payload?.id) || 0;
      const booksData = state.options?.books?.slice(0) || [];
      const allBooksData = state.allOptions?.books?.slice(0) || [];
      if (bookId) {
        if (booksData?.length) {
          const index = booksData.findIndex((val) => val.id === bookId);
          if (index > -1) {
            booksData.splice(index, 1);
          }
        }
        if (allBooksData?.length) {
          const indexPage = allBooksData.findIndex((val) => val.id === bookId);
          if (indexPage > -1) {
            allBooksData.splice(indexPage, 1);
          }
        }
      }
      return {
        ...state,
        options: {
          ...(state.options || {}),
          books: booksData
        },
        allOptions: {
          ...(state.allOptions || {}),
          books: allBooksData
        },
      }
    }
    case UPDATE_ITEM_IN_MASTER_OPTIONS: {
      const itemId = parseInt(action.payload?.id) || 0;
      const data = action.payload?.data;
      const itemsData = state.options?.items?.slice(0) || [];
      const allItemsData = state.allOptions?.items?.slice(0) || [];
      if (data) {
        if (itemsData?.length) {
          const index = itemsData.findIndex((val) => val.id === itemId);
          if (index > -1) {
            itemsData.splice(index, 1, data);
          }
        }
        if (allItemsData?.length) {
          const indexPage = allItemsData.findIndex((val) => val.id === itemId);
          if (indexPage > -1) {
            allItemsData.splice(indexPage, 1, data);
          }
        }
      }
      return {
        ...state,
        options: {
          ...(state.options || {}),
          items: itemsData
        },
        allOptions: {
          ...(state.allOptions || {}),
          items: allItemsData
        },
      }
    }
    case ADD_ITEM_IN_MASTER_OPTIONS: {
      const data = action.payload?.data;
      const itemsData = state.options?.items?.slice(0) || [];
      const allItemsData = state.allOptions?.items?.slice(0) || [];
      if (data) {
        itemsData.unshift(data);
        allItemsData.unshift(data);
      }
      return {
        ...state,
        options: { 
          ...(state.options || {}),
          items: itemsData
        },
        allOptions: {
          ...(state.allOptions || {}),
          items: allItemsData
        },
      }
    }
    case DELETE_ITEM_IN_MASTER_OPTIONS: {
      const itemId = parseInt(action.payload?.id) || 0;
      const itemsData = state.options?.items?.slice(0) || [];
      const allItemsData = state.allOptions?.items?.slice(0) || [];
      if (itemId) {
        if (itemsData?.length) {
          const index = itemsData.findIndex((val) => val.id === itemId);
          if (index > -1) {
            itemsData.splice(index, 1);
          }
        }
        if (allItemsData?.length) {
          const indexPage = allItemsData.findIndex((val) => val.id === itemId);
          if (indexPage > -1) {
            allItemsData.splice(indexPage, 1);
          }
        }
      }
      return {
        ...state,
        options: {
          ...(state.options || {}),
          items: itemsData
        },
        allOptions: {
          ...(state.allOptions || {}),
          items: allItemsData
        },
      }
    }
    default:
      return state;
  }
};

export default masterOptionsReducer;